/* eslint-disable */ ;
console.log = function () {}
console.warn = function () {}

var vh;
var activeSeectIssue;

function initWindoHeight() {
	vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}
initWindoHeight();
$(window).resize(function () {
	initWindoHeight();
})
$('.menuIcon').click(function (e) {
	e.preventDefault();
	$('.hamburger').toggleClass('is-active')
	$('.mainMenu').toggleClass('ishidden')
	$('html').toggleClass('menuToggled noScroll')
});
$('.language.icon').click(function (e) {
	e.preventDefault();
	// debugger
	$('.languages').toggleClass('fadeOut');
	$('html').toggleClass('languagesToggled');

});





//
function goto(event) {
	var closeMainMenu = '.mainMenu * , .menuIcon ,.menuIcon *';
	var Closelang = '.language';
	var CloseDeskTopSearch = '.search-box ,.search-box *';


	if (!event.target.matches(closeMainMenu)) {

		$('.hamburger').removeClass('is-active')
		$('.mainMenu').addClass('ishidden')
		$('html').removeClass('menuToggled noScroll')

	}
	if (!event.target.matches(Closelang)) {
		$('.languages').addClass('fadeOut');
		$('html').removeClass('languagesToggled');


	}
	if (!event.target.matches(CloseDeskTopSearch)) {
		$('.search-box').removeClass('active');



	}
};
document.body.addEventListener('click', goto);



$('.category').click(function (e) {
	e.preventDefault();
	//$(this).find('.arrow').toggleClass('active')
});

$(function () {
	setTimeout(() => {
		$('#loader').addClass('hidden')
	}, 700);
});

var lastScrollTop = 0;
$(window).scroll(function (event) {
	var st = $(this).scrollTop();
	if ($(window).width() > 768) {

		if (st > lastScrollTop) {
			// downscroll code
			$('.languages').addClass('fadeOut')
		} else {
			// upscroll code
			$('.languages').addClass('fadeOut')
		}
	}
	lastScrollTop = st;

	//mob-header
	pageY = window.pageYOffset;

	if ($('.header').length > 0) {
		showHomeMenu();
	}
});



if (!$('.homePage').length) {
	$('body').css('background', 'white');
	// $('.page-container').addClass('homePageFix')

}


if (($('.extraForms').length > 0) || ($('.form-ronded').length > 0)) {
	$('.page-container').addClass('page-has-form')

}




$('input[type="file"]').change(function (e) {
	var fileName = e.target.files[0].name;
	$(this).parent().find('.custom-file-label').addClass('choosed').html(fileName);
});



if ($('.search-btn').length > 0) {
	function searchToggle(obj, evt) {
		var container = $(obj).closest('.search-box');
		if (!container.hasClass('active')) {

			container.addClass('active');
			container.find('.search-input').focus();
			evt.preventDefault();

		} else if (container.hasClass('active') && $(obj).closest('.input-holder').length == 0) {
			container.removeClass('active');
			// clear input
			container.find('.search-input').val('');
		}

	}
	$('.search-btn').click(function () {
		searchToggle(this, event);

	})

}


// End Search Wrappe


if ($('#innerNav').length) {
	// When the user scrolls the page, execute myFunction
	window.onscroll = function () {
		myFunction()
	};


	// Get the navbar
	var navbar = document.getElementById("innerNav");

	// Get the offset position of the navbar
	var sticky = navbar.offsetTop;
	// debugger
	// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function myFunction() {
		console.log($('.innerNav').position().top)
		if (window.pageYOffset >= 300) {
			navbar.classList.add("sticky")
		} else {
			navbar.classList.remove("sticky");
		}
	}
}


$('.collapse').on('show.bs.collapse', function () {
	$(this).siblings('.accordion-header').find('.icon').addClass('active opened');
	let that = $(this);

})



$(".wrapper .collapse").on("shown.bs.collapse", function (e) {
	let that = $(this);
	//to stop Scrolling on show add class no-scroll-on-show to body
	if (!$('body').hasClass("no-scroll-on-show")) {
		setTimeout(function () {
			if ((that.closest(".wrapper").length > 0) && (!that.closest(".header").length > 0) && (!that.closest("#footer").length > 0)) {

				var n = that.closest(".wrapper");
				var head_height = n.find('.accordion-header').innerHeight() + 50;
				if ($('.header').length > 0) {
					head_height = $('.header').innerHeight() + n.find('.accordion-header').innerHeight();
				}
				$("html,body").animate({
					//	scrollTop: n.offset().top - head_height - n.find('.accordion-header').innerHeight()
					scrollTop: n.offset().top - head_height
				}, 300)
			}
		}, 10)
	}
})







$('.collapse').on('hide.bs.collapse', function () {
	$(this).siblings('.accordion-header').find('.icon').removeClass('active opened')
})

$('.videoWrapper').click(function (e) {
	e.preventDefault();
	if ($(this).hasClass('playing')) {
		$(this).removeClass('playing')
		$(this).find('.videoCover').removeClass('fadeOut')
		$(this).find('.playButton .play').removeClass('paused')
		document.getElementById("entertainmentVideo").pause();
	} else {
		$(this).addClass('playing')
		$(this).find('.videoCover').addClass('fadeOut')
		$(this).find('.playButton .play').addClass('paused')
		document.getElementById("entertainmentVideo").play();
	}
});

$(`.faqDropdown .selectpickerCustom`).selectpicker();

function initSelectPickerCustom() {
	$(`.faqDropdown .selectpickerCustom`).on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		let selectedLabel = $($(e.target).children()[clickedIndex]).attr('label')
		$(this).val(e.target.value)
		$(this).parent().parent().find('.selectedValue').html(selectedLabel)
	});
	$(`.faqDropdown .selectpickerCustom`).on('show.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		$(this).parent().parent().find('.arrow').addClass('active');
	});

	$(`.faqDropdown .selectpickerCustom`).on('hide.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		$(this).parent().parent().find('.arrow').removeClass('active');
	});



	$('.extraForms .selectpickerCustom.changeOnSelect').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		let val = e.target.value
		console.log('sss', val);
		activeSeectIssue = val;
		//$('.IssueSelect').addClass('d-none');
		$('.extraForms  .IssueSelect').addClass('d-none').removeClass('activeChoice onlyOne');
		if ($('.no-data').length > 0) {
			$('.no-data').addClass('d-none');

		}
		$('.' + val + 'IssueSelect').removeClass('d-none').addClass('activeChoice');
		if (($('.' + val + 'IssueSelect').length == 1)) {
			$('.' + val + 'IssueSelect').removeClass('d-none').addClass('activeChoice onlyOne');

		}
		if (($('.no-data').length > 0) && ($('.' + val + 'IssueSelect')).length < 1) {
			$('.no-data').removeClass('d-none');

		}


	});

}
initSelectPickerCustom();

function onSubmit() {
	console.log('submit');
}
$('.extraForms .inputradio').change(function () {

	let val = $(this).val();
	$('.extraForms  .inputradioSelect').addClass('d-none');
	$('.' + val + 'inputradioSelect').removeClass('d-none').addClass('hop');
})
$('.paymentMethodControl').change(function () {
	let val = $(this).val();
	if (val == 'creditCard') {
		$('.creditCardForm').removeClass('d-none');
		$('.madaCardForm').addClass('d-none');
		$('.fawryForm').addClass('d-none');
		$('.knetForm').addClass('d-none');
	} else if (val == 'mada') {
		$('.madaCardForm').removeClass('d-none');
		$('.creditCardForm').addClass('d-none');
		$('.fawryForm').addClass('d-none');
		$('.knetForm').addClass('d-none');
	} else if (val == 'knet') {
		$('.knetForm').removeClass('d-none');
		$('.madaCardForm').addClass('d-none');
		$('.creditCardForm').addClass('d-none');
		$('.fawryForm').addClass('d-none');
	} else if (val == 'fawry') {
		$('.fawryForm').removeClass('d-none');
		$('.madaCardForm').addClass('d-none');
		$('.creditCardForm').addClass('d-none');
		$('.knetForm').addClass('d-none');
	}
});



//const body = document.body;
const body = document.querySelector(".header");
let pageY = 0;

const scrollUp = "scroll-up";
const scrollDown = "hide-on-scroll";
let lastScroll = 100;




//
function showHomeMenu() {
	let scrolled = 100;
	// if ($(window).width() < 768) {
	if ($(window).width() > 0) {

		scrolled = 0;
		//
		const currentScroll = window.pageYOffset;
		if (currentScroll == 100) {
			body.classList.remove(scrollUp);
			return;
		}

		if (currentScroll - 90 > lastScroll && !body.classList.contains(scrollDown)) {
			// down
			body.classList.remove(scrollUp);
			body.classList.add(scrollDown);
		} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
			// up
			body.classList.remove(scrollDown);
			body.classList.add(scrollUp);
			if ($('.innerNav.sticky').length > 0) {
				$('.innerNav.sticky').removeClass('sticky');

			}


		}
		lastScroll = currentScroll;
		//

	}

	if ($(window).width() > 768) {
		$('.hamburger').removeClass('is-active')
		$('.mainMenu').addClass('ishidden')
		$('html').removeClass('menuToggled noScroll')
	}
	if (pageY >= scrolled) {
		//showMainMenuItems()

	}


}


//for the datepicker
if (typeof calenderOpens === "undefined") {
	calenderOpens = "left";
}

function initTheDatePicker() {
	$('.datepicker').daterangepicker({
		'opens': calenderOpens,
		singleDatePicker: true,
		autoApply: true,
		// locale: {
		// 	format: 'DD MMM YY'
		// }
		locale: calenderLocal,


	}, function (start, end, label) {
		console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
	});


}
if ($('.datepicker').length > 0) {
	require('daterangepicker');
	const moment = require('moment');
	moment.locale(localLang);
	initTheDatePicker();
	$(".datepicker").each(function (index) {
		let placeHolder = $(this).attr('placeholder');
		let value = $(this).attr('value');
		if (typeof value === "undefined" || value == " ") {
			$(this).val('');
			$(this).attr("placeholder", placeHolder);
		}

	});

}


//addMoreAgain
if ($('.addMoreAgain').length > 0) {
	let click = 0;

	function checkstopadd(element) {
		let stopadd = $(element).attr('limit') - 1;

		if (stopadd === null) {} else {
			if (stopadd <= click) {
				$(element).addClass('d-none')
			} else {
				$(element).removeClass('d-none')
			}
		}
	}
	$(document).on('click', '.addMoreAgain', function (event) {
		let parent = $(this).parents('.section');
		click++;
		let newFilels = parent.find('.form-row').eq(0).clone();
		var deletebutton = `<span class="deleteFileld deleteRow" ><svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M512 60.333L451.667 0L255.999 195.666L60.333 0L0 60.333L195.666 255.999L0 451.667L60.333 512L255.999 316.334L451.666 512L511.999 451.667L316.334 255.999L512 60.333Z" fill="black"></path>
			</svg> </span>`;
		newFilels.append(deletebutton);
		newFilels.addClass('addedRow pr-4 pr-md-0 position-relative').find('.form-group').removeClass('has-error has-success').find('.messages').html('');


		var inputs = newFilels.find(".form-control");

		for (var i = 0; i < inputs.length; i++) {
			$(inputs[i]).val("");
			console.log($(inputs[i]).attr("name"));
			let str = $(inputs[i]).attr("name");
			var mySubString = str.substring(
				str.lastIndexOf("[") + 1,
				str.lastIndexOf("]")
			);
			var mynewSubString = mySubString + '_' + click
			str = str.replace(mySubString, mynewSubString);
			console.log('eee', str);
			$(inputs[i]).attr('name', str);
		}

		newFilels.appendTo(parent.find('.all'));
		checkstopadd($(this));

		if ($(newFilels.find('.datepicker').length > 0)) {
			initTheDatePicker()
			// $(parent.find('.datepicker')).val('');
			// $(parent.find('.datepicker')).attr("placeholder", "Check In");
		}



	})
	$(document).on('click', '.addedRow .deleteFileld', function (event) {
		click--;
		checkstopadd($(this).parents('.section').find('.addMoreAgain'));
		$(this).parent().remove();

	})
}

if ($('.innerSearch').length > 0) {
	let URL = $(".innerSearch  .searchButton .btn-search").attr('href');
	let SelectedCatKey = '&category='
	let ActiveCat = '1';

	function getActiveSearch() {
		let Val = $('.innerSearch .search-input').val();
		ActiveCat = $('.innerSearch .selectpickerCustom').val();
		let NURL = URL + encodeURI(Val) + SelectedCatKey + ActiveCat;
		$(".innerSearch .btn-search").attr('href', NURL);
	}
	$(".innerSearch .search-input").on("change paste keyup", function () {
		getActiveSearch();
		//console.log(NURL)
	});

	$(`.innerSearch .selectpickerCustom`).on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		//ActiveCat = e.target.value;

		getActiveSearch();

	});
	getActiveSearch();

}



//offeres-list

if ($('.specialOffersList').length > 0) {
	var containerEl = document.querySelector('.specialOffersList');
	$('.filter-offeres .dropdown-toggle').attr('data-filter', 'all')

	//start init Sort Price


	var sortOrder = 'desc',
		$container = $('.specialOffersList'),
		$toggleSort = $('.toggle-sort');

	var mixer = mixitup(containerEl, {
		load: {
			sort: 'price:desc'
		},
		controls: {
			scope: 'local'
		}
	})
	console.log('mixer', mixer);
	$toggleSort.on('click', function () {
		$toggleSort.toggleClass('asc-sort')
		$toggleSort.find('.arrow').toggleClass('active');

		switch (sortOrder) {
			case 'asc':
				sortOrder = 'desc';
				console.log('desc')
				break;
			case 'desc':
				sortOrder = 'asc';
				console.log('asc')



				break;
		}

		$container.mixItUp('sort', 'price:' + sortOrder);
		console.log('container', $container);

	});

	//end init Sort Price
	$('.extraForms .selectpickerCustom.getDataonChange').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {


		//mixer.destroy();
		let val = e.target.value

		let dataurl = dataUrl + val;
		$('.smloader').removeClass('d-none');
		$('.filter-all').addClass('loadNow');
		$('.theAllList').html('');
		$.getJSON(dataurl, function (data) {
			console.log('length', data.data.length);
			mixer.destroy();

			//containerEl.parentElement.removeChild(containerEl);
			$('.no-data').addClass('d-none');
			$('.theAllList').html(data.data);
			$('.smloader').addClass('d-none');
			$('.filter-all').removeClass('loadNow');
			var changeDependency = $('.selectpickerCustom.getDataonChange').attr('changeDependency');
			if (typeof changeDependency !== 'undefined' && changeDependency !== false) {
				console.log('dd', data.dependencySelect);
				$('.filter-offeres .dependencySelect .faqDropdown').html(data.dependencySelect);
				$('.filter-offeres .dropdown-toggle').attr('data-filter', 'all')

				$('.dependencySelect .faqDropdown .selectpickerCustom').selectpicker();
				$('.filter-offeres .dropdown-toggle').attr('data-filter', 'all');
				initSelectPickerCustom();

			} else {
				console.log('activeSeectIssue', activeSeectIssue);
				var selectedOffer = typeof activeSeectIssue !== 'undefined' && activeSeectIssue != null && activeSeectIssue != 'null' && activeSeectIssue != "";

				if (activeSeectIssue) {
					$('.specialOffersList  .IssueSelect').addClass('d-none');
					$('.specialOffersList').find('.' + activeSeectIssue + 'IssueSelect').removeClass('d-none').addClass('hop');
				}
			}

			setTimeout(() => {
				if (($('.specialOffersList .mix').length) < 1) {

					$('.no-data').removeClass('d-none');

				} else {
					$container = $('.specialOffersList');
					// $toggleSort = $('.toggle-sort');
					var containerEl = document.querySelector('.specialOffersList');

					mixer = mixitup(containerEl, {
						load: {
							sort: 'price:' + sortOrder
						},
						controls: {
							scope: 'local'
						}
					})
				}
			}, 10)
		});


	});

	// });
}



// open Accordion

let url = '';
let furl = window.location.href;

function GetURLParameter(sParam) {

	var sPageURL = window.location.search.substring(1);

	var sURLVariables = sPageURL.split('&');

	for (var i = 0; i < sURLVariables.length; i++) {

		var sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] == sParam) {

			return sParameterName[1];

		}

	}

}
if (typeof itemU !== 'undefined') {
	// variable is undefined

	if (furl.indexOf('?' + itemU + '=') != -1) {
		let active_qus = (GetURLParameter(itemU));
		if ((active_qus) && ($('*[data-id=' + active_qus + ']').length) > 0) {
			//$('*[data-id=' + active_qus + ']').addClass('active').find('.collapse').collapse('show')
			$('*[data-id=' + active_qus + ']').addClass('active');
			$('*[data-id=' + active_qus + ']').addClass('active').find('.collapse').addClass('show')
			$('*[data-id=' + active_qus + ']').find('.icon').addClass(' active opened')
			var n = $('*[data-id=' + active_qus + ']');
			console.log('sss' + n.offset().top - $('.header').outerHeight());

			//	n.addClass('active')
			setTimeout(() => {
				$("html,body").animate({
					scrollTop: n.offset().top - $('.header').outerHeight()
				}, 500);
			}, 200);


		}



	}
	$(".collapse").on("hide.bs.collapse", function (e) {

		if ((history.pushState)) {
			//url = "?";
			url = "";
			window.history.pushState({
				path: url
			}, '', url);

		}

	})
}

//select filter (newslist.html)
$('.MediaListFilter .selectpickerCustom').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
	let mediaList = $(this).parents().closest('.MediaListFilter');

	mediaList = $(mediaList);
	let val = e.target.value;
	let that = $(this);
	mediaList.find($('.smloader')).removeClass('d-none');
	mediaList.find($('.media-list')).html('');
	var selectUrl = $(that).find('option:selected').attr('data-url');
	let selectedMonth = mediaList.find($('.monthSelect')).find("option:selected").val();
	let selectedYear = mediaList.find($('.yearSelect')).find("option:selected").val();
	selectUrl = selectUrl + '&year=' + selectedYear + '&month=' + selectedMonth;

	console.log('selectUrl', selectUrl);

	$.getJSON(selectUrl, function (data) {
		console.log('data.data', data.data);
		if (typeof data === 'object') {
			mediaList.find($('.media-list')).html(data.data);
			mediaList.find($('.smloader')).addClass('d-none');
			if ((mediaList.find($('.media-list .item')).length) < 1) {

				mediaList.find($('.media-list .no-data')).removeClass('d-none');

			}

		}
	})

})



// //custom.js
// if($('.showLgMap').length>0){
// 	$('.showLgMap').click(function(){
// 	  let map=$(this).attr('data-map');
// 	  $('.fleetModal .map-img-wrap img').attr('src',map)
// 	  $('.fleetModal').modal('show');
// 	})
// }